import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {ListItemText } from '@mui/material';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AddUser from '../../users/AddUser';
import { StyledMenu } from './StylesMenu';

export default function UserDropDown({ users, fetchUserData }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const [openAdd, setOpenAdd] = useState(false);
  const location = useLocation();
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
    handleClose();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickRoute = () => {
    setAnchorEl(null);
    if (location.pathname !== '/users') {
      navigate('/settings?view=users');
    }
  };

  return (
    <>
      <Button
        id="project-dropdown"
        aria-controls={open ? 'project-dropdown-btn' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="text"
        disableElevation
        sx={{ color: 'var(--primary-color)', fontWeight: 'bold', ml: 5 }}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}>
        Users
      </Button>
      <StyledMenu
        id="project-dropdown-btn"
        MenuListProps={{
          'aria-labelledby': 'project-dropdown',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        {/* <MenuItem onClick={handleClose} sx={{ pointerEvents: 'none' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            Your Collaborators
          </Typography>
        </MenuItem>

        {users && users.length > 0 ? (
          users?.map((user) => {
            return (
              <MenuItem key={user.id}>
                <ListItemIcon>
                  <People />
                </ListItemIcon>
                <ListItemText
                  primary={`${user.name}`}
                  secondary={user.email}
                  primaryTypographyProps={{
                    sx: { fontWeight: 'bold', color: 'navyblue' },
                  }}
                  secondaryTypographyProps={{
                    sx: {
                      color: 'grey.500',
                      fontSize: '0.75rem',
                      textTransform: 'none',
                    },
                  }}
                />
              </MenuItem>
            );
          })
        ) : (
          <MenuItem sx={{ pointerEvents: 'none' }}>
            <ListItemText
              primary="No User Added Yet"
              sx={{ textAlign: 'center', color: 'navyblue' }}
            />
          </MenuItem>
        )}
        <Divider sx={{ borderColor: 'black', my: 0.5 }} /> */}
        <MenuItem onClick={handleClickRoute}>
          <ListItemText
            sx={{ textAlign: 'center' }}
            primary=" View All Members"
          />
        </MenuItem>
        <Divider sx={{ borderColor: 'black', my: 0.5 }} />
        <MenuItem onClick={handleClickOpenAdd}>
          <ListItemText
            sx={{ textAlign: 'center' }}
            primary="Invite New Member"
          />
        </MenuItem>
      </StyledMenu>
      <AddUser
        open={openAdd}
        setOpen={setOpenAdd}
        fetchUsersData={fetchUserData}
      />
    </>
  );
}
